export default __webpack_public_path__ + "media/images/carnival/apartment_sample_sp-ed6af1f422219feaec4bde090d816202.jpg";